import type { Actions, State } from './typings'
import { initialState } from './initialState'
import { fetchCallTrackingDetailsProducer } from './actions'

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'trackingCall/fetchDetails':
      return fetchCallTrackingDetailsProducer(state, action.payload)
    default:
      throw Error(`There is no reducer for ${action.type}`)
  }
}
